import { useCallback } from 'react';
import { uploadMatterDetail, uploadToSignedUrl } from '../service/uploadService';

export const useCancellableUpload = () => {

  const uploadFile = useCallback(async ({ file, matter, id, folder, newly_created, relative_path, onUploadProgress, override_existing, batchId }, abortController) => {
    try {
      const response = await uploadMatterDetail({ 
        file: file, 
        matter: matter, 
        folder: (folder ? id : null), 
        newly_created,
        relative_path,
        signal: abortController.signal, // Pass the abort signal
        onUploadProgress,
        override_existing,
        batchId,
      });
      
      return response;
    } catch (error) {
      if (error.name === 'AbortError') {
        throw new Error('Upload cancelled');
      }
      throw error;
    }
  }, []);

  const uploadFileToSignedUrl = useCallback(async ({ file, signedUrl, onUploadProgress, contentType }, abortController) => {
    try {
      const response = await uploadToSignedUrl({
        file,
        signedUrl,
        signal: abortController.signal,
        onUploadProgress,
        contentType,
      });
      
      return response;
    } catch (error) {
      if (error.name === 'AbortError') {
        throw new Error('Upload cancelled');
      }
      throw error;
    }
  }, []);

  return { uploadFile, uploadFileToSignedUrl };
}; 